import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import {
  AppContext,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import { IC } from "../../../resources/Assets";
import { closeLayerFn, Container, openLayerFn } from "../../Layout";

import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import { getCookie } from "../../../modules/utils/cookie";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg, deviceCfg, phonecfg } = useContext(AppContext);
  useTitle("마이페이지_악세사리");

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleConfirm = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleCancelCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  const handleConfirmCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  const handleWithdrawalConfirm = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };

  const handleWithdrawalCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleWithdrawalConfirmCB = () => {
    closeLayerFn($(".confirm-layer"));
  };
  // 다이얼로그 ]]

  const calcAge = birth => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = "0" + month;
    }

    if (day < 10) {
      day = "0" + day;
    }

    let monthDay = month + day;

    birth = birth.replace("-", "").replace("-", "");

    let birthdayy = birth.substr(0, 4);
    let birthdaymd = birth.substr(4, 4);
    let age = monthDay < birthdaymd ? year - birthdayy - 1 : year - birthdayy;

    return age;
  };

  const putJsonData = () => {
    // sex, age, height
    let sex = getCookie("sex") == "1" ? 0 : 1;
    let age = calcAge(getCookie("birth"));
    let height = "";

    if (getCookie("hght")) {
      height = getCookie("hght");
    }

    return {
      sex: parseInt(sex),
      age: parseInt(age),
      height: parseInt(height),
    };
  };

  useEffect(() => {
    socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
  }, []);

  useEffect(() => {
    userHabit(phonecfg, "ST110");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <Container
        Title={"설정"}
        dark={"dark"}
        isMain={false}
        /*bottom={list.length === 0 ? <Bottom /> : null}*/ goToUrl={"/mp"}>
        <div className="contents">
          <div className="sub-contents">
            <div className="device-link-contain">
              {deviceCfg.deviceTypes.map((m, i) =>
                m.devices.length > 0
                  ? i < 2 && <DeviceType key={i} deviceType={m} />
                  : null
              )}
            </div>
          </div>
        </div>
      </Container>

      <AlertLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleConfirmCB}
      />

      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleWithdrawalCancelCB}
        handleConfirmCB={handleWithdrawalConfirmCB}
      />
    </Fragment>
  );
};

const DeviceType = ({ deviceType }) => {
  return (
    <div>
      <div className={getClassNameTitle(deviceType.typeName)}>
        <div className="title">
          <i className={getClassNameIcon(deviceType.typeName)}></i>{" "}
          {deviceType.typeName}
        </div>

        {deviceType.devices.map((m, i) => (
          <Device key={i} device={m} seqNo={i} />
        ))}
      </div>
    </div>
  );
};

const Device = ({ device, seqNo }) => {
  const deviceInfo = {
    BP170B: {
      name: "BP170B",
      company: "인바디",
      image: IC.bp170b.THUMNAIL,
    },
    OMRON: {
      name: "OMRON",
      company: "오므론",
      image: IC.omron.THUMNAIL,
    },
    "ACCU-CHEK Instant": {
      name: "ACCU-CHEK Instant",
      company: "로슈(Roche)",
      image: IC.accucheck.THUMNAIL,
    },
    "GluNEO Smart": {
      name: "GluNEO Smart",
      company: "(주)오상",
      image: IC.gluneo.STEP2,
    },
    F62E_B: {
      name: "F62E_B",
      company: "(주)오상",
      image: IC.gluneo.STEP2,
    },
  };

  const setMadeCompany = deviceName => {
    let returnValue = "";

    if (deviceName === "BP170B") {
      returnValue = deviceInfo["BP170B"];
    }

    if (deviceName === "OMRON") {
      returnValue = deviceInfo["OMRON"];
    }

    if (deviceName === "ACCU-CHEK Instant") {
      returnValue = deviceInfo["ACCU-CHEK Instant"];
    }

    if (deviceName === "GluNEO Smart" || deviceName === "GluNEO") {
      returnValue = deviceInfo["GluNEO Smart"];
    }

    if (deviceName === "F62E_B") {
      returnValue = deviceInfo["F62E_B"];
    }

    // return deviceInfo[deviceName.split("-")[0]];
    return returnValue;
  };

  return (
    <div style={{ height: "100px" }}>
      <a
        style={{ height: "100px", display: "flex", lineHeight: "24px" }}
        onClick={e => _O.OpenMenu(device.link + "/" + seqNo)}>
        <div
          style={{ marginTop: "14px", width: "67.81px", textAlign: "center" }}>
          <img
            src={setMadeCompany(device.deviceName).image}
            style={{ height: "72px", paddingRight: "10px" }}
          />
        </div>
        <div style={{ marginTop: "25px" }}>
          <div style={{ fontWeight: "700" }}>
            {setMadeCompany(device.deviceName).name}
          </div>
          <div>{setMadeCompany(device.deviceName).company}</div>
        </div>
        <div>
          {device.isConnected === true ? (
            <span style={{ paddingTop: "38px" }}>연결됨</span>
          ) : null}
          {/* <span>연결됨</span> */}
        </div>
      </a>
    </div>
  );
};

const getClassNameTitle = typeName => {
  var className = "";

  switch (typeName) {
    case "혈압계":
      className = "round-list green";
      break;
    case "혈당계":
      className = "round-list pink";
      break;
    case "체중계":
      className = "round-list purple";
      break;
    default:
      className = "round-list";
      break;
  }

  return className;
};

const getClassNameIcon = typeName => {
  var className = "";

  switch (typeName) {
    case "혈압계":
      className = "c1";
      break;
    case "혈당계":
      className = "c2";
      break;
    case "체중계":
      className = "c3";
      break;
    default:
      className = "c1";
      break;
  }

  return className;
};

export const calcAge = birth => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) {
    month = "0" + month;
  }

  if (day < 10) {
    day = "0" + day;
  }

  let monthDay = month + day;

  birth = birth.replace("-", "").replace("-", "");

  let birthdayy = birth.substr(0, 4);
  let birthdaymd = birth.substr(4, 4);
  let age = monthDay < birthdaymd ? year - birthdayy - 1 : year - birthdayy;

  return age;
};

export const putBodyData = () => {
  // sex, age, height
  let sex = getCookie("sex") == "1" ? 0 : 1;
  let age = calcAge(getCookie("birth"));
  let height = "";

  if (getCookie("hght")) {
    height = getCookie("hght");
  }

  return {
    sex: parseInt(sex),
    age: parseInt(age),
    height: parseInt(height),
  };
};
